import { Module } from '@nestjs/common'
import { ReservationSharedModule } from '../shared'
import { ReservationReminderCron } from './reservation-reminder.cron'
import { ReservationSeederCron } from './reservation-seeder.cron'

@Module({
	imports: [ReservationSharedModule],
	providers: [ReservationReminderCron, ReservationSeederCron],
})
export class ReservationCronModule {}
